import { getValues } from "../../../../helpers/Utils";

export const getColumnsWithoutLastElement = (columns, lastElement) => {
	if (!lastElement?.name) {
		return getValues(columns);
	}
	return getValues(columns).filter((column) => !column?.isLastElement);
};
